// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '165.788px',
}

const propTypes = {
  width: PropTypes.string,
}

// Component
function IconPin({ width, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      {...props}
      viewBox="0 0 165.788 161.469"
    >
      <path
        fill="#0070f2"
        opacity="0.148"
        d="M89.573,0c35.294,0,38.238,8.062,38.238,42.285S94.593,94.327,63.905,104.253,0,76.509,0,42.285,54.279,0,89.573,0Z"
        transform="matrix(0.799, 0.602, -0.602, 0.799, 63.713, 0)"
      />
      <rect
        fill="#fff"
        width="10"
        height="15"
        transform="translate(87 61.469)"
      />
      <g transform="translate(52 28.275)">
        <g transform="translate(0 7.194)">
          <path
            fill="#0056bf"
            d="M22.7,354.185a1.144,1.144,0,0,0-1.557-.41l-2.851,1.655v-3.294a1.131,1.131,0,0,0-2.261,0v3.294l-2.851-1.655a1.138,1.138,0,0,0-1.147,1.966l2.868,1.671-2.868,1.671a1.138,1.138,0,0,0,1.147,1.966l2.851-1.655v3.294a1.131,1.131,0,0,0,2.261,0V359.4l2.851,1.655a1.138,1.138,0,1,0,1.147-1.966l-2.868-1.671,2.868-1.671A1.134,1.134,0,0,0,22.7,354.185Z"
            transform="translate(-9.591 -294.667)"
          />
          <path
            fill="#0056bf"
            d="M143.123,360.541a1.144,1.144,0,0,0,1.557.41l2.851-1.655v3.294a1.131,1.131,0,1,0,2.261,0V359.3l2.851,1.655a1.138,1.138,0,1,0,1.147-1.966l-2.868-1.671,2.868-1.671a1.138,1.138,0,1,0-1.147-1.966l-2.851,1.655v-3.294a1.131,1.131,0,1,0-2.261,0v3.294l-2.851-1.639a1.138,1.138,0,1,0-1.147,1.966l2.868,1.671-2.868,1.655A1.144,1.144,0,0,0,143.123,360.541Z"
            transform="translate(-119.542 -294.583)"
          />
          <path
            fill="#0f7efb"
            d="M131.5,457.674v2a.874.874,0,0,0,.868.868h13.421a.874.874,0,0,0,.868-.868v-2a.874.874,0,0,0-.868-.868H132.368A.864.864,0,0,0,131.5,457.674Z"
            transform="translate(-109.952 -383.13)"
          />
          <path
            fill="#0f7efb"
            d="M168.89,25.861h-.1V21.4A14.145,14.145,0,0,0,154.716,7.2,13.878,13.878,0,0,0,141.1,21.043v.426a1.168,1.168,0,0,0,1.163,1.163h3.72a1.168,1.168,0,0,0,1.163-1.163v-.131a7.992,7.992,0,0,1,7.292-8.079,7.8,7.8,0,0,1,8.292,7.767v4.818H151.258v.016h-10.6A3.656,3.656,0,0,0,137.1,29.5V49.654a3.658,3.658,0,0,0,3.654,3.654h28.12a3.658,3.658,0,0,0,3.654-3.654V29.515A3.633,3.633,0,0,0,168.89,25.861Zm-11.9,14.633a.787.787,0,0,0-.361.737c.016,1.475.016,2.95,0,4.441h0a1.554,1.554,0,0,1-.836,1.491,1.732,1.732,0,0,1-2.589-1.491V41.215a.773.773,0,0,0-.328-.7,3.367,3.367,0,0,1-1.114-4.162,3.445,3.445,0,0,1,6.587,1.36A3.12,3.12,0,0,1,156.993,40.494Z"
            transform="translate(-114.634 -7.194)"
          />
          <path
            fill="#0f7efb"
            d="M262.9,457.674v2a.874.874,0,0,0,.868.868h13.421a.874.874,0,0,0,.868-.868v-2a.874.874,0,0,0-.868-.868H263.768A.874.874,0,0,0,262.9,457.674Z"
            transform="translate(-219.819 -383.13)"
          />
          <path
            fill="#0056bf"
            d="M274.523,360.541a1.144,1.144,0,0,0,1.557.41l2.851-1.655v3.294a1.131,1.131,0,0,0,2.261,0V359.3l2.851,1.655a1.138,1.138,0,1,0,1.147-1.966l-2.868-1.671,2.868-1.671a1.138,1.138,0,1,0-1.147-1.966l-2.851,1.655v-3.294a1.131,1.131,0,0,0-2.261,0v3.294l-2.851-1.655a1.138,1.138,0,1,0-1.147,1.966l2.868,1.671-2.868,1.671A1.144,1.144,0,0,0,274.523,360.541Z"
            transform="translate(-229.41 -294.583)"
          />
          <path
            fill="#0f7efb"
            d="M408.589,456.806H395.169a.874.874,0,0,0-.868.868v2a.874.874,0,0,0,.868.868h13.421a.874.874,0,0,0,.868-.868v-2A.874.874,0,0,0,408.589,456.806Z"
            transform="translate(-329.687 -383.13)"
          />
          <path
            fill="#0f7efb"
            d="M.868,460.542H14.289a.874.874,0,0,0,.868-.868v-2a.874.874,0,0,0-.868-.868H.868a.874.874,0,0,0-.868.868v2A.874.874,0,0,0,.868,460.542Z"
            transform="translate(0 -383.13)"
          />
          <path
            fill="#0056bf"
            d="M405.986,360.541a1.144,1.144,0,0,0,1.557.41l2.851-1.655v3.294a1.131,1.131,0,0,0,2.261,0V359.3l2.851,1.655a1.138,1.138,0,1,0,1.147-1.966l-2.868-1.671,2.868-1.671a1.138,1.138,0,1,0-1.147-1.966l-2.851,1.655v-3.294a1.131,1.131,0,0,0-2.261,0v3.294l-2.851-1.655a1.138,1.138,0,0,0-1.147,1.966l2.868,1.671-2.868,1.671A1.13,1.13,0,0,0,405.986,360.541Z"
            transform="translate(-339.324 -294.583)"
          />
        </g>
      </g>
      <path
        fill="#0056bf"
        d="M0,0H0A4,4,0,0,1,4,4V23.5a4,4,0,0,1-4,4H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
        transform="translate(106 54.068)"
      />
    </svg>
  )
}

IconPin.defaultProps = defaultProps
IconPin.propTypes = propTypes

export default IconPin
